// 我的APP
import request from '@/axios/axios'

// 获取app
export function fetchApp(query) {
  return request({
    url: 'ota/v1/app/info/get',
    method: 'POST',
    data: query
  })
}

// 创建app
export function addApp(query) {
  return request({
    url: 'ota/v1/app/info/add',
    method: 'POST',
    data: query
  })
}

// 编辑app
export function updateApp(query) {
  return request({
    url: 'ota/v1/app/info/update',
    method: 'POST',
    data: query
  })
}

// 删除app
export function deleteApp(query) {
  return request({
    url: 'ota/v1/app/info/delete',
    method: 'POST',
    data: query
  })
}

// 上传版本升级文件
export function uploadFile(query) {
  return request({
    url: 'ota/v1/app/version/info/upload/version/file',
    method: 'POST',
    data: query
  })
}

// 新增版本
export function addVersion(query) {
  return request({
    url: 'ota/v1/app/version/info/add',
    method: 'POST',
    data: query
  })
}

// 编辑版本
export function updateVersion(query) {
  return request({
    url: 'ota/v1/app/version/info/update',
    method: 'POST',
    data: query
  })
}

// 编辑版本
export function versionList(query) {
  return request({
    url: 'ota/v1/app/version/info/get-app-version-info-list',
    method: 'POST',
    data: query
  })
}

// 测试版本
export function testVersion(query) {
  return request({
    url: 'ota/v1/app/version/info/test',
    method: 'POST',
    data: query
  })
}

// 上线版本
export function onlineVersion(query) {
  return request({
    url: 'ota/v1/app/version/info/online',
    method: 'POST',
    data: query
  })
}

// 下线版本
export function offlineVersion(query) {
  return request({
    url: 'ota/v1/app/version/info/offline',
    method: 'POST',
    data: query
  })
}

// 删除版本
export function deleteVersion(query) {
  return request({
    url: 'ota/v1/app/version/info/delete',
    method: 'POST',
    data: query
  })
}

// 获取app可升级版本（安卓）
export function latestAndroidVersion() {
  return request({
    url: 'ota/v1/app/version/info/get-app-latest-version-for-android',
    method: 'POST'
  })
}
